import React from "react";
import DiaryHeader from "./DiaryHeader";
import PatientDetails from "./PatientDetails";
import EmployeeDetails from "./EmployeeDetails";
import ExtraDetails from "./ExtraDetails";
import NonServiceReasons from "./NonServiceReasons";
import WorkPlan from "./WorkPlan";
import DailyPlan from "./DailyPlan";
import DailyPlanComments from "./DailyPlanComments";
import FamilyMember from "./FamilyMember";
import CaregiverApproval from "./CaregiverApproval";
import CompanyApproval from "./CompanyApproval";
import Statements from "./Statements";
import TextItem from "../../../components/print/workDiary/TextItem";
import DiaryWrapper from "./Diary.style";
import _ from "lodash";

const Diary = (props) => {
  const { activeRecord, currentDate, type, print } = props;
  const manualEvents = _.sortBy(activeRecord.manual_events, [
    function (o) {
      return o.date;
    },
  ]);
  const allEvents = _.sortBy(
    [...activeRecord.manual_events, ...activeRecord.scheduled_recurrent_events],
    [
      function (o) {
        return o.date;
      },
    ]
  );
  const totalMinutes = allEvents.reduce(
    (sum, event) => sum + event.duration_minutes,
    0
  );
  const totalHours = totalMinutes / 60;

  return (
    <DiaryWrapper print={print}>
      <DiaryHeader
        currentDate={currentDate}
        patient={activeRecord.patient}
        selectedClientName={activeRecord.order.client.name}
        clientCategory={activeRecord.order.client.category.name}
        type={type}
      />
      <div className="flexdContainer">
        <div style={{ display: "flex", width: "43%" }}>
          <PatientDetails type={type} patient={activeRecord.patient} />
          <div
            style={{
              width: "20px",
            }}
          />
          <EmployeeDetails
            employee={activeRecord.employee}
            patient={activeRecord.patient}
          />
        </div>
        <div style={{ display: "flex", width: "57%" }}>
          <div style={{ marginRight: "10px", display: "flex", flex: 1 }}>
            <ExtraDetails
              employee={activeRecord.employee}
              patient={activeRecord.patient}
              staff_worker_in_charge={activeRecord.staff_worker_in_charge}
              employeeEvents={activeRecord.recurrent_work_events}
              effective_from={activeRecord.order.effective_from}
              effective_to={activeRecord.order.effective_to}
              max_hours_per_month={activeRecord.order.max_hours_per_month}
              totalHours={totalHours}
            />
          </div>
          <div
            style={{
              display: "flex",
              marginRight: "10px",
              width: "fit-content",
            }}
          >
            <NonServiceReasons />
          </div>
        </div>
      </div>

      <WorkPlan
        employeeEvents={activeRecord.recurrent_work_events}
        manualEvents={manualEvents}
        print={print}
      />
      <DailyPlan
        currentDate={currentDate}
        print={print}
        activeRecord={activeRecord}
      />
      <DailyPlanComments />
      <div className="spacerContainer">
        <FamilyMember />
        <div style={{ width: "10px" }} />
        <div style={{ width: "45%" }}>
          <CaregiverApproval employee={activeRecord.employee} />
        </div>
        <div style={{ width: "10px" }} />
        <CompanyApproval />
      </div>
      <Statements employee={activeRecord.employee} />
      <div className="vertical_spacer" />
      <TextItem name="family_member_description" />
    </DiaryWrapper>
  );
};

export default Diary;
